export const NAME = 'toasters';
export const TYPES = {
  DEFAULT: 'DEFAULT',
  FAILURE: 'FAILURE',
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
};
